import { titleCase } from '../../common/include';
import { parseValue } from 'common/include';
import { getCleanGameName, getCleanThemeName } from 'common/common';
import { heatBeanRatings } from 'config/HeatBeanRatings';
export const InsertGameNameToSlot = (selectedInsight, slot, slotData) => {
  const gameTitle = getCleanGameName(slot.game_name);
  const gameTheme = getCleanThemeName(slot.game_name);
  const formattedTitle = titleCase(gameTitle);
  const formattedTheme = titleCase(gameTheme);
  const slotNumber = slot.slot_number;

  let appendText = '';
  switch (selectedInsight) {
    case 'money_won':
      appendText =
        slot?.money_won !== undefined ? `${parseValue(slot.money_won, 'money_won')} Won` : '';
      break;
    case 'spins':
      appendText = slot?.spins !== undefined ? `${parseValue(slot.spins, 'spins')} Spins` : '';
      break;
    case 'avg_money_won_per_spin':
      appendText =
        slot?.avg_money_won_per_spin !== undefined
          ? `${parseValue(slot.avg_money_won_per_spin, 'avg_money_won_per_spin')} Win/Spin`
          : '';
      break;
    case 'non_jkpt_won_per_spin':
      appendText =
        slot?.non_jkpt_won_per_spin !== undefined
          ? `${parseValue(slot.non_jkpt_won_per_spin, 'non_jkpt_won_per_spin')} W/S-J`
          : '';
      break;
    case 'jackpot_value_per_spin':
      appendText =
        slot?.jackpot_value_per_spin !== undefined
          ? `${parseValue(slot.jackpot_value_per_spin, 'jackpot_value_per_spin')} J/S`
          : '';
      break;
    case 'win_rate':
      appendText =
        slot?.win_rate !== undefined ? `${parseValue(slot.win_rate, 'win_rate')} %WS` : '';
      break;
    case 'jackpot_value':
      appendText =
        slot?.jackpot_value !== undefined
          ? `${parseValue(slot.jackpot_value, 'jackpot_value')} | ${parseValue(slot.jackpots, 'jackpots')} JKPTs`
          : '';
      break;
    case 'jackpots':
      appendText =
        slot?.jackpots !== undefined ? `${parseValue(slot.jackpots, 'jackpots')} | ${parseValue(slot.jackpot_value, 'jackpot_value')}  JKPTs` : '';
      break;
    case 'money_played':
      appendText =
        slot?.money_played !== undefined
          ? `${parseValue(slot.money_played, 'money_played')} Play`
          : '';
      break;
    case 'return':
      appendText = slot?.return !== undefined ? `${parseValue(slot.return, 'return')} RTP` : '';
      break;
    case 'pop':
      appendText = slot?.pop !== undefined ? `${parseValue(slot?.pop, 'pop')} POP` : '';
      break;
    case 'sleeper_slot_rating':
      appendText =
        slot?.sleeper_slot_rating !== undefined
          ? `${parseValue(slot?.sleeper_slot_rating_ntile, 'sleeper_slot_rating')} SSR`
          : '';
      break;
    case 'volatility_rating':
      appendText =
        slot?.volatility_rating !== undefined
          ? `${parseValue(slot?.volatility_rating_ntile, 'volatility_rating')} VOL`
          : '';
      break;
  }
  return {
    slotNumber,
    gameTitle: formattedTitle,
    gameTheme: formattedTheme,
    insightText: appendText,
  };
};

export const mapConfiguration = (map) => {};

export const setPreferenceHeatMapColor = (map, heatFilter) => {
  let newHeatFilter = [];
  for (let i = 6; i >= 1; i--) {
    if (heatFilter.length > 0) {
      const eachIndex = heatFilter.indexOf(i);
      if (eachIndex !== -1) {
        newHeatFilter.push(['match', ['feature-state', 'heat'], [i], true, false]);
        newHeatFilter.push(heatBeanRatings[i].color);
      } else {
        newHeatFilter.push(['match', ['feature-state', 'heat'], [i], true, false]);
        newHeatFilter.push(heatBeanRatings[i].light_color);
      }
    } else {
      newHeatFilter.push(['match', ['feature-state', 'heat'], [i], true, false]);
      newHeatFilter.push(heatBeanRatings[i].color);
    }
  }

  map.setPaintProperty('slotLayer', 'fill-color', [
    'case',
    newHeatFilter[0],
    newHeatFilter[1],
    newHeatFilter[2],
    newHeatFilter[3],
    newHeatFilter[4],
    newHeatFilter[5],
    newHeatFilter[6],
    newHeatFilter[7],
    newHeatFilter[8],
    newHeatFilter[9],
    newHeatFilter[10],
    newHeatFilter[11],
    heatBeanRatings[0].color,
  ]);
};
